import { makeObservable, observable } from 'mobx'

import i18n from 'modules/core/lib/i18n'

import { AttachedFile } from './AttachedFile'
import { Block, BlockConfig } from './Block'

export type VideoBlockConfig = BlockConfig & {
  video?: AttachedFile
}

export class VideoBlock extends Block {
  video: AttachedFile

  constructor(config: VideoBlockConfig = {}) {
    super(config)

    this.video = config.video || new AttachedFile()

    makeObservable(this, {
      video: observable,
    })
  }

  validate(): Record<string, string> {
    const errors = { ...super.validate() }
    if (this.video.isEmpty()) {
      errors.video = i18n.t('trainings.content.validation.video_required')
    }
    return errors
  }

  clone(): VideoBlock {
    return new VideoBlock({
      id: this.id,
      uuid: this.uuid, // Preserve uuid for tracking
      title: this.title,
      accesible: this.accesible,
      status: this.status,
      video: this.video,
    })
  }
}
